import throttle           from 'lodash.throttle';

export default class Header {

    static get selector() {
        return '.header';
    }

    constructor(el) {
        this.el = el;
        this.limit = 20;
        this.isFixed = window.pageYOffset > this.limit;
    
        this.lastScroll = window.pageYOffset;

        this.setEvents();
    }

    /**
     * Events
     */
    
    setEvents() {
        window.addEventListener('scroll', throttle((e) => {
            this.e_scroll(e);
        }, 50));
    }

    e_scroll(e) {

        // Check if is fixed
        this.isFixed = window.pageYOffset > this.limit;
        if(this.isFixed) {
            this.el.classList.add('header--scrolled');
            if(window.pageYOffset < this.lastScroll ){
                this.el.classList.add('header--scrolledup')
            }else{
                this.el.classList.remove('header--scrolledup')
            }
    
        }else {
            this.el.classList.remove('header--scrolled');
            this.el.classList.remove('header--scrolledup');
        }
        this.lastScroll = window.pageYOffset;
    }

}

